export const messages = {
  rules: [
    'La clave puede tener un mínimo de ocho caracteres.',
    'La clave debe contener obligatoriamente caracteres númericos y alfabeticos.',
    'Transcurridos 30 minutos de conexión, el sistema lo obligará a reingresar.',
    'El cambio de clave es obligatorio cada 30 días.',
    'La clave no podrá ser igual a ninguna de las utilizadas anteriormente.',
  ],
  tips: [
    'No introduzca la clave frente a otras personas.',
    'No dé a conocer su clave a otras personas.',
    'No utilice claves triviales (p.e. nombres, fechas de nacimiento, números de documentos, etc.).',
  ],
};
